import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface MatchParams {}

type Props = RouteComponentProps<MatchParams>;

class ScrollToTop extends Component<Props> {
  componentDidUpdate(prevProps: Props) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
